import { render, staticRenderFns } from "./MerchantBusinessGeneralDetailsManagement.vue?vue&type=template&id=5c36ff7a&scoped=true&"
import script from "./MerchantBusinessGeneralDetailsManagement.vue?vue&type=script&lang=js&"
export * from "./MerchantBusinessGeneralDetailsManagement.vue?vue&type=script&lang=js&"
import style0 from "./MerchantBusinessGeneralDetailsManagement.vue?vue&type=style&index=0&id=5c36ff7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c36ff7a",
  null
  
)

export default component.exports